import { render, staticRenderFns } from "./08_ap_tipos_tasas.vue?vue&type=template&id=53625de8&scoped=true&"
import script from "./08_ap_tipos_tasas.vue?vue&type=script&lang=js&"
export * from "./08_ap_tipos_tasas.vue?vue&type=script&lang=js&"
import style0 from "./08_ap_tipos_tasas.vue?vue&type=style&index=0&id=53625de8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53625de8",
  null
  
)

export default component.exports